import { Component, Input } from '@angular/core';
import { LicenseWithCompletionResource } from '../../../core/models';

@Component({
  selector: 'app-progress-bar',
  imports: [],
  templateUrl: './progress-bar.component.html',
  styleUrl: './progress-bar.component.scss'
})
export class ProgressBarComponent {

  @Input() license!: LicenseWithCompletionResource;

}
